import { Field } from 'formik'
import React from 'react'
import { useQuery } from 'react-query'

import placeService from '../../services/placeService'
import { Image } from '../../types/utils'
import { useUser } from '../../hooks/useUser'

import FormikInput from '../FormikInput'
import FormikTextarea from '../FormikTextarea'
import FormikDragZone from '../FormikDragZone'
import FormikSelect from '../FormikSelect'
import FormikCheckbox from '../FormikCheckbox'

type DetailsFormProps = {
  isSubmitting: boolean
  heroImage: string | null
  locationValidationQrCode: Image
}

const DetailsForm: React.FC<DetailsFormProps> = (props) => {
  const categories = useQuery(['place-categories'], placeService.getAllCategories)
  const user = useUser()

  return (
    <div className="space-y-6 p-6">
      <Field name="customer" component={FormikInput} label="Customer" disabled />
      <fieldset className="grid gap-6 lg:grid-cols-2" disabled={props.isSubmitting}>
        <Field
          name="categories"
          component={FormikSelect}
          label="Category*"
          options={
            categories.data?.map(({ name, id }) => ({
              value: id,
              label: name,
            })) || []
          }
          placeholder="Type Category"
          isMulti
          isLoading={categories.isLoading}
          isDisabled={user.data?.type !== 'BUZZL'}
        />
        <Field name="address" component={FormikInput} label="Address" disabled />
      </fieldset>
      <fieldset disabled={props.isSubmitting}>
        <Field name="description" component={FormikTextarea} label="Description" placeholder="Location description" />
        <p className="mt-1 text-sm text-gray-500">If nothing is provided, fallback will be used</p>
      </fieldset>
      <fieldset className="grid gap-6 lg:grid-cols-2" disabled={props.isSubmitting}>
        <Field name="actionText" component={FormikInput} label="Action Button Text" />
        <Field name="actionUrl" component={FormikInput} label="Action Button URL" type="url" />
      </fieldset>
      <fieldset className="grid gap-6 lg:grid-cols-2" disabled={props.isSubmitting}>
        <div>
          <Field
            name="configFlags.isGeolocationCheckEnabled"
            component={FormikCheckbox}
            label="Enable Location Check?"
            orientation="LEFT"
          />
          <p className="ml-7 mt-1 text-sm text-gray-500">
            Require users to be within 500m of your Google Location to Verify their review? Not recommended for large
            venues such as sports grounds and hotels.
          </p>
        </div>
      </fieldset>
      <fieldset disabled={props.isSubmitting} className="mb-6 grid items-start gap-5 lg:grid-cols-2">
        <Field component={FormikDragZone} label="Photo" name="heroImage" placeholderImage={props.heroImage} />
        <div>
          <p className="mb-1 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">QR Code</p>
          <div className="flex items-center">
            <img
              src={props.locationValidationQrCode.url}
              alt={props.locationValidationQrCode.altText}
              className="h-36"
            />
            <a
              className="btn btn-white"
              href={`${props.locationValidationQrCode.url}&response-content-disposition=attachment;
`}
              download={props.locationValidationQrCode.altText}
              target="_blank"
              rel="noreferrer nofollow"
            >
              Download
            </a>
          </div>
        </div>
      </fieldset>
    </div>
  )
}

export default DetailsForm
